var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kun_loading108_container"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"planet"},[_c('div',{staticClass:"ring"}),_c('div',{staticClass:"cover-ring"}),_c('div',{staticClass:"spots"},[_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('span')])]),_c('p',[_vm._v("loading")])])])
}]

export { render, staticRenderFns }